/* eslint-disable no-unused-vars */
/* eslint-disable default-param-last */
const initialState = {
  values: [],
  isEdited: false,
  isAdded: false,
  type: null,
  action: null,
};
const notificationFormReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'ADD':
      return {
        ...state,
        values: payload,
      };
    case 'DEL':
      return {
        ...state,
        values: [],
        isEdited: false,
      };
    case 'EDITED':
      return {
        ...state,
        isEdited: payload,
      };
    case 'ADDED':
      return {
        ...state,
        isAdded: payload,
      };
    case 'SET_TYPE':
      return {
        ...state,
        type: payload,
      };
    case 'SET_ACTION':
      return {
        ...state,
        action: payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default notificationFormReducer;
